export const environment = {
    production: true,
    isLocalhost: false,
};
